// @flow
export const StatusApplication = {
  pending: 'pending',
  pending_payment: 'pending_payment',
  documents_requested: 'documents_requested',
  approved: 'approved',
  declined: 'declined',
  canceled: 'canceled',
  screening: 'screening'
};

export const StepsIndexApplication = {
  account: 0,
  profile: 1,
  income: 2,
  references: 3,
  documents: 4,
  payment: 5,
  resume: 6,
  extra: 7,
  previous_landlord: 8,
  complete: 9
};

export const StatusHome = {
  rejected: 'rejected',
  reserved: 'reserved',
  canceled: 'canceled',
  rented: 'rented',
  temporarily_canceled: 'temporarily_canceled',
  unpublished: 'unpublished',
  published: 'published'
};

export const PRODUCT_SEEKER = 'product_seeker';

export const isProductSeeker = home => {
  const { home_application } = home;
  if (!home_application) return false;
  return home_application.source === PRODUCT_SEEKER;
};
